export default "__VITE_ASSET__BO8R_9Bt__"